import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../../App.routing'

function widgetComponent(isWidgetFallbackEnabled: boolean) {
    if (!isWidgetFallbackEnabled) {
        return [
            layout.component({
                type: 'stats-medal-tally',
                props: {
                    isFullSize: false,
                },
            }),
        ]
    } else {
        return [
            layout.component({
                type: 'lima',
                props: {
                    section: 'default',
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                    cardLayout: [
                        [
                            'xsImage-mdNoImage-withBG',
                            'xsImage-mdNoImage-withBG',
                        ],
                    ],
                    intermediateColumns: 1,
                    finalColumns: 1,
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'olympics',
                        pageSize: 2,
                        offset: 7,
                    },
                    hasBorder: false,
                },
            }),
        ]
    }
}

export function olympicsCurationSegment(props: {
    isWidgetFallbackEnabled: boolean
}) {
    return layout.nestedComposition({
        type: 'thor',
        feature: 'the-west-tokyo',
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: 'tokyo',
            usePodcastToggleValue: true,
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

                        dataDefinitionArgs: {
                            type: 'curation',
                            name: 'olympics',
                            offset: 0,
                            pageSize: 2,
                        },
                    },
                }),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: true,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'sm',
                                    hasBorder: true,
                                    usePodcastToggleValue: true,
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'default',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['teaserWithBackground'],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                ],
                                                intermediateColumns: 3,
                                                finalColumns: 3,
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'olympics',
                                                    pageSize: 5,
                                                    offset: 2,
                                                },
                                                hasBorder: false,
                                            },
                                        }),
                                    ],
                                    right: widgetComponent(
                                        props && props.isWidgetFallbackEnabled,
                                    ),
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}
